// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.web-order-list .wo-act { color:#0A0AFF; text-decoration:underline; cursor:pointer; margin-right:4px;\n}\n", ""]);
// Exports
module.exports = exports;
